export const TokenStatus = Object.freeze({
    VERIFYING: 100,
    VERIFIED: 200,
    FAILED: 300,
  });
  